(() => {
  const trustPilotRatingsFetch = () => {
    if(window.trustPilotRatings) return window.trustPilotRatings
    return fetchApiWu(`/staticassets/app-ratings/trustpilot-ratings.json`, {
      method: "GET"
    }, "trustpilotRatingApi")
    .then((response) => {
      window.trustPilotRatings = response
      return response
    })
  }

  const appRatingsFetch = (country) => {
    window.wuAppRatings = window.wuAppRatings || {}
    if (window.wuAppRatings[country]) return window.wuAppRatings[country]

    window.wuAppRatings[country] = fetchApiWu(`/staticassets/app-ratings/${country}-ratings.json`, {
      method: "GET"
    }, "starRatingApi")
    return window.wuAppRatings[country]
  }

  const updateMobilePromptRating = (response) => {
    const androidRating = Number(response?.android?.average_rating) || 0
    const iosRating = Number(response?.ios?.average_rating) || 0
    const rating = Math.max(androidRating, iosRating)
    document.querySelectorAll('[data-mobile-app-prompt-rating]').forEach((ratingBlock) => {
      if (rating) {
        ratingBlock.querySelector('.rating-dynamic')?.replaceChildren(rating.toFixed(1))
        ratingBlock.classList.remove('d-none')
      }
    })
  }

  window.wuAppRatingsFetch = appRatingsFetch
  window.updateMobilePromptRating = updateMobilePromptRating

  const removeDnoneStarRating = (starRatings) => {
    starRatings?.forEach(starRating => starRating.classList?.remove('d-none'))
  }

  // Function to create an SVG element with an image
  const createSvgElement = (width, height, href) => {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", width);
    svg.setAttribute("height", height);
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    const image = document.createElementNS("http://www.w3.org/2000/svg","image");
    image.setAttribute("width", width);
    image.setAttribute("height", height);
    image.setAttribute("href", href);
    svg.appendChild(image);
    return svg;
  }

  try {
    const starRatings1 = document.querySelectorAll('.star-rating-4-2');
    const starRatings2 = document.querySelectorAll('.star-rating-4-5');
    const starRatings3 = document.querySelectorAll('.star-rating-5');
    const ratingsValue = document.querySelectorAll('.rating-value');
    const numberOfReviews = document.getElementById('number_of_reviews')
  if (starRatings1?.length && starRatings2?.length && starRatings3?.length) {
      trustPilotRatingsFetch()
      .then((response) => {
        let {rating, numberOfReviews: {total}} = response
        ratingsValue?.forEach((ratingValue) => {
          ratingValue.textContent = rating
        });
        if(total && numberOfReviews) {
          numberOfReviews.innerHTML = numberOfReviews.innerHTML.replace("{{number_of_reviews}}", total.toLocaleString('en-US'))
        } else {
          numberOfReviews?.classList.add('d-none')
        }
        
        if( rating<=4.2){  
          removeDnoneStarRating(starRatings1)
        } else if(rating>4.2 && rating<4.6){
          removeDnoneStarRating(starRatings2)
        } else  if(rating>4.6 && rating<=5){
          removeDnoneStarRating(starRatings3)
        }
      })
    }

    const spanTrustpilotElement = document.getElementById("trustpilot-star-svg");
    if (spanTrustpilotElement) {
      trustPilotRatingsFetch().then((response) => {
        const trustScore = response.rating || "4.3";
        const reviewCount = response.numberOfReviews?.total?.toLocaleString('en-US') || "127,942";
        const logoObj = response.trustpilot_logo?.darkBackground?.logoSvg;
        const logoUrl = logoObj?.url || 'https://images-static.trustpilot.com/api/logos/dark-bg/logo.svg';
        const logoHeight = 24;
        // const logoWidth = 128;
        const starObj = response.star_image?.starSvg;
        const starUrl = starObj?.url || '//images-static.trustpilot.com/api/stars/4.5/star.svg';
        const starWidth = 136;
        const starHeight = 24;
        spanTrustpilotElement.innerHTML = '';
        const outerSpan = document.createElement('span');
        const link = document.createElement('a');
        link.href = spanTrustpilotElement.getAttribute('data-href-trustpilot')
        link.target = "_blank";
        link.rel = "nofollow";
        link.setAttribute("aria-describedby","audioeye_new_window_message")
        const wrapSpan = document.createElement('span');
        wrapSpan.className = 'd-flex';
        const starSpan = document.createElement('span');
        starSpan.className = 'font-label-01 font-weight-500 text-white d-flex align-items-center pad-8-bm ';
        starSpan.innerHTML = `<svg width="${starWidth}" height="${starHeight}" xmlns="http://www.w3.org/2000/svg" aria-label="Trustpilot star rating"><image width="${starWidth}" height="${starHeight}" href="${starUrl}"></image></svg>`;       
        wrapSpan.appendChild(starSpan);
       
        const logoSpan = document.createElement('span');
        logoSpan.className = 'font-label-01 font-weight-500 text-white d-flex align-items-center pad-8-bm';
        const logoImg = document.createElement('img');
        
        logoImg.src = logoUrl;
        logoImg.alt = 'Trustpilot logo white';
        logoImg.height = logoHeight;
        // logoImg.width = logoWidth;
        logoSpan.appendChild(logoImg);
        wrapSpan.appendChild(logoSpan);
        link.appendChild(wrapSpan);
        
        const scoreSpan = document.createElement('span');
        scoreSpan.className = 'text-white d-flex align-items-center pad-xs-bm pad-4-tp pad-4-lt font-body-02 font-weight-400';
        scoreSpan.innerHTML = `<p>TrustScore ${trustScore} | ${reviewCount} reviews</p>`;
        outerSpan.appendChild(link);
        outerSpan.appendChild(scoreSpan);
        spanTrustpilotElement.appendChild(outerSpan);
      });
    }
    

    const template = window?.pageData?.template?.templateName
    const scriptEl = document.getElementById('wuJsonLd')
    const appStoreLinks = document.querySelectorAll(".onelink_qrcode,.onelink_appstore")
    const appRatingBlock = document.querySelector('.app-dynamic-rating')
    const appRatingBlockHome = document.querySelector('.app-dynamic-rating-home')
    const mobileAppPromptRatings = document.querySelectorAll('[data-mobile-app-prompt-rating]')
    if (mobileAppPromptRatings.length) {
      appRatingsFetch(window.pageData.country).then(updateMobilePromptRating)
    }
    if(scriptEl && (template=='Corridor Template' || template== 'WUDS 2.0 Template' || appStoreLinks?.length > 0 ))  {
      const country = window.pageData.country
    const ratingTextEl = document.querySelectorAll(".ratings-text")
    const setRatingDate = (finalDate) => {
      Array.from(ratingTextEl).forEach((el) => {
        if (finalDate) {
          el.innerHTML = el.innerHTML.replace("{{ratingDate}}", finalDate);
        } else {
          el.classList.add("d-none");
        }
      });
    };
    appRatingsFetch(country)
      .then((jsonResponse) => {
          const android_ratings = jsonResponse?.['android']?.['average_rating']?.toFixed(1)
          const ios_ratings = jsonResponse?.['ios']?.['average_rating']?.toFixed(1)
          const finalDate = ((android_ratings || ios_ratings) && jsonResponse?.finalDate) ? jsonResponse?.finalDate : '';
          updateMobilePromptRating(jsonResponse)
          
          appRatingBlockHome && setRatingDate(finalDate)

          if(android_ratings > 4 && ios_ratings > 4) {
            Array.from(appStoreLinks).forEach((el) => {
              const ratingEl = el.parentElement.querySelector('span.rating-dynamic')
              const starRatingsEL = el.parentElement.querySelector("[data-lazyload-mobile-desktop-class='stars-rating']") ||
                el.parentElement.querySelector("[data-lazyload-mobile-desktop-class='stars-rating-yellow']")
              const imageEl = el.querySelector("img")

              setRatingDate(finalDate)

              if(ratingEl && starRatingsEL && imageEl) {
                const src = imageEl.getAttribute("data-lazyload-mobile-desktop-src")?.toLowerCase()
                if(src.includes("google") || src.includes("play")) {
                    ratingEl.innerText = android_ratings
                } else {
                  ratingEl.innerText = ios_ratings
                }
                starRatingsEL.setAttribute("style", `width:calc(11.5px * ${ratingEl.innerText});`)
              }
            })
          } else {
            appRatingBlock?.classList.remove("d-L-block", "d-M-block")
          }
        const jsonLd = JSON.parse(scriptEl.textContent);
        const graphData = jsonLd['@graph']
        for(let i = 0; i < graphData.length; i++) {
            let type = graphData[i]['@type'];
            if(type=='Product') {
              let android_rating = jsonResponse?.android?.average_rating || 0
              let ios_rating = jsonResponse?.ios?.average_rating || 0
              let appExist = (android_rating || ios_rating) ? true : false
              if(appExist) {
                let app = (android_rating>ios_rating) ? 'android' : 'ios'
                jsonLd['@graph'][i]['review']['reviewRating']['bestRating']=5
                jsonLd['@graph'][i]['review']['reviewRating']['ratingValue']=jsonResponse?.[app]?.average_rating
                jsonLd['@graph'][i]['aggregateRating']['ratingValue']=jsonResponse?.[app]?.average_rating
                jsonLd['@graph'][i]['aggregateRating']['ratingCount']=jsonResponse?.[app]?.total
              } else {
                jsonLd['@graph'][i] = ''
              }
            }
        }
        scriptEl.textContent=JSON.stringify(jsonLd)
      }) 
      const trustPilotSection = document.querySelector(".trustpilot-section")
      if(trustPilotSection) {
        trustPilotRatingsFetch()
        .then((response) => {
          let {rating: tpRating} = response
          const trustRatingEl = trustPilotSection.querySelector('.rating-count')

          if(trustRatingEl && response>=4) {
              const hideEle = document.querySelector('.hide-section')
              trustRatingEl.textContent = tpRating
              hideEle?.classList?.add('d-none')
              trustPilotSection?.classList?.remove('d-none')
          }
        })
      }
    }
  } catch (e) {
    console.log("error in one link and ratings")
  }
})()